import { Bookings } from '../Bookings';
import { EnvironmentModes } from '../../api/implementations/environmentModes';
import { BusinessInfo } from '../BusinessInfo';
import { UserInfo } from '../Userinfo';
import { SelectedTimezone } from '../SelectedTimezone';
import { SelectedTab } from '../SelectedTab';
import { ModalContext } from '../ModalContext';
import { ToastContext } from '../ToastContext';
import { SettingsInfo } from '../Settings';
import { CancellationFeeInfo } from '../CancellationFeeInfo';
import { SubmissionInfo } from '../SubmissionInfo';

export type ApplicationState = {
  status: ApplicationStatus;
  environmentModes: EnvironmentModes;
  settingsInfo?: SettingsInfo;
  selectedTab: SelectedTab;
  upcomingData?: Bookings;
  historyData?: Bookings;
  businessInfo?: BusinessInfo;
  userInfo?: UserInfo;
  selectedTimezone?: SelectedTimezone;
  timezoneRevision?: number;
  modalContext?: ModalContext;
  toastContext?: ToastContext;
  cancellationFeeInfo?: CancellationFeeInfo;
  submissionInfo?: SubmissionInfo;
};

export enum ApplicationStatus {
  IDLE = 'idle',
  INITIALIZING = 'initializing',
}

export enum BusinessTimezoneTypes {
  BUSINESS = 'business',
  USER = 'client',
}
